<template>
  <button :class="buttonClass" :type="type" @click="onClick">
    <font-awesome-icon v-if="icon" :icon="icon" />
    <span v-if="icon">&nbsp;&nbsp;</span>
    <slot></slot>
  </button>  
</template>

<script>
import fas from '@fortawesome/fontawesome-free-solid'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    type: {
      type: String,
      default: 'button',
    },
    context: {
      type: String,
      default: 'default',
    },
    icon: {
      type: String,
      default: '',
    },
    onClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    fas() { return fas },
    buttonClass() {
      return `StdButton StdButton--${this.context}`
    },
  },
}
</script>

<style scoped>
.StdButton {
  border: none;
  border-radius: 3px;
  box-sizing: border-box;
  color: #FFF;
  cursor: pointer;
  font-weight: 700;
  height: 42px;
  line-height: 42px;
  margin: 0;
  min-width: 190px;
  max-width: 380px;
  padding: 0 16px;
  text-align: center;
  transition: all 0.2s;
}

.StdButton:hover {
  box-shadow: 0 2px 8px 8px rgba(0,0,0,0.1);
  transform: scale(1.1, 1.1);
}

.StdButton:active {
  box-shadow: 0 2px 4px 3px rgba(0,0,0,0);
  transform: scale(1, 1);
}

.StdButton:focus {
  outline: none;
}

.StdButton--default {
  background: #36ab6f;
}

.StdButton--secondary {
  background: #3c4148;
  border: 2px solid #cbd7eb;
  color: #cbd7eb;
  line-height: 38px;
}

.StdButton--outline {
  background: transparent;
  border: 2px solid #3c4148;
  box-shadow: none;
  color: #3c4148;
  line-height: 38px;
}

.StdButton--outline:hover {
  background: #3c4148;
  box-shadow: 0 2px 8px 8px rgba(0,0,0,0.1);
  color: #FFF;
  transform: scale(1.1, 1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/StdButton/StdButton.vue